import { Injectable } from '@angular/core';
import { environment } from '../../../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserDetails } from '../../../../models/auth/user-details';
import { BackendService } from '../../../backend.service';

@Injectable({
  providedIn: 'root',
})
export class UserProfileService {
  baseURL: string = `${environment.baseUrl}/`;
  constructor(
    private http: HttpClient,
    private backendService: BackendService,
  ) {}

  getUserProfile(authData: any): Observable<any> {
    const { access_token, decodedUserInfo } = authData;
    const headers = new Headers({
      'Content-Type': 'application/json',
      Authorization: `Bearer ${access_token}`,
    });
    return this.backendService.getWithParams(`${this.baseURL}profile/${decodedUserInfo.guid}/`, { headers }).pipe(map((res) => res));
  }

  updateProfile(userId: number, userDetails: UserDetails): Observable<any> {
    return this.http.put(`${this.baseURL}profile/${userId}/`, userDetails).pipe(map((res) => res));
  }

  partialUpdateProfile(userId: number, userDetails: UserDetails): Observable<any> {
    return this.http.patch(`${this.baseURL}profile/${userId}/`, userDetails).pipe(map((res) => res));
  }
}
